import { SiteItemData } from "../../../../interfaces";
import { VideoGalleryVerticalMutam } from "./videoGalleryVerticalMutam";

export interface categoryObj {
    id: string
    categoryColor: string
    name:string
}

interface MagazineVideoGalleryVerticalMutamComponentaProps {
    videoList: SiteItemData[]
    isTabVisible: boolean
    tabTitleText: string
    firstAdPlace: number
    maxAds: number
    repeatAds: number
    shouldDisplayMobileAds: boolean
    category: categoryObj
    hideMoreButton:boolean 
    moreButtonText:string
    domain: string
    showPrerollAds: boolean
}

export class MagazineVideoGalleryVerticalMutamComponenta extends React.Component<MagazineVideoGalleryVerticalMutamComponentaProps, {}>{
    public static siteScriptName = "MagazineVideoGalleryVerticalMutamComponenta";

    public render() {
        const { videoList, hideMoreButton,moreButtonText,  isTabVisible, tabTitleText, repeatAds, maxAds, firstAdPlace, shouldDisplayMobileAds, category, domain, showPrerollAds } = this.props;

        return (
            <div className="magazineVideoGalleryVerticalMutamComponenta">
                <VideoGalleryVerticalMutam
                    videoList={videoList}
                    isTabVisible={isTabVisible}
                    tabTitleText={tabTitleText}
                    repeatAds={repeatAds}
                    maxAds={maxAds}
                    firstAdPlace={firstAdPlace}
                    hideMoreButton={hideMoreButton}
                    moreButtonText={moreButtonText}
                    shouldDisplayMobileAds={shouldDisplayMobileAds}
                    category={category}
                    domain={domain}
                    showPrerollAds={showPrerollAds}/>
            </div>
        )
    }
}
